import { apiRequest, encryptPayload } from "@nusrif/utils";
import { ApiResponse, TrackingApiEvent } from "@nusrif/types";

// Utility to generate a UUID (v4)
function generateUUID(): string {
  // Standard RFC4122 version 4 UUID implementation
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = crypto.getRandomValues(new Uint8Array(1))[0] % 16;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

const TRACKING_ID_KEY = "nusrif-id";

export function getTrackingId(): string {
  let id = localStorage.getItem(TRACKING_ID_KEY);
  if (!id) {
    id = generateUUID();
    localStorage.setItem(TRACKING_ID_KEY, id);
  }
  return id;
}

export function setTrackingId(id: string) {
  localStorage.setItem(TRACKING_ID_KEY, id);
}

/**
 * Track an event with the tracking API.
 */
export async function trackEvent(event: TrackingApiEvent): Promise<ApiResponse<null>> {
    const payload = await encryptPayload({
        event: event.event,
        properties: {
            ...event.properties,
            distinct_id: getTrackingId(),
            timestamp: new Date().toISOString()
        }
    });
    const response = await apiRequest<ApiResponse<null>>('/track', {
        method: 'POST',
        body: {
            payload
        }
    });

    return response;
}